// import $ from "jquery"
import ReCAPTCHA from "react-google-recaptcha"
import { useForm } from "react-hook-form"
import { toast } from "react-toastify"
import { VALID_EMAIL, VALID_NAME, VALID_PHONE } from "../../constants"
import { getApiDataPromise } from "../../models/ApiData"

export default function ContactForm() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()
  let in_progress = false

  const onSubmit = async function (data: any) {
    if (in_progress) return

    in_progress = true

    data["g-recaptcha-response"] = $('[name="g-recaptcha-response"]').val()
    if (!data["g-recaptcha-response"]) {
      toast.error("Please fill out the reCAPTCHA!")
      return
    }

    var result = await getApiDataPromise(data, "public_data", "send_ticket")

    if (result.success) {
      toast.success("Successful!")
      $("#message_form").hide()
      $("#success_message").show()
    } else {
      toast.error(result.message)
      in_progress = false
    }
  }
  return (
    <>
      <form id="message_form" onSubmit={handleSubmit(onSubmit)}>
        <div className="steps__form">
          <div className="steps__form_boxing">
            <div className="row">
              <div className="col-lg-6 padding_right_30">
                <div className="form__item">
                  <input
                    type="text"
                    className="input input_small"
                    placeholder="Name"
                    {...register("name", { required: true, ...VALID_NAME })}
                  />
                  {errors.name && <span className="erorrs">{(errors.name?.message as string) || "This field is required"}</span>}
                </div>
              </div>
              <div className="col-lg-6 padding_left_30">
                <div className="form__item">
                  <input
                    type="text"
                    className="input input_small"
                    placeholder="Email"
                    id="email"
                    {...register("email", { required: true, ...VALID_EMAIL })}
                  />
                  {errors.email && <span className="erorrs">{errors.email?.message as string}</span>}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 padding_right_30">
                <div className="form__item">
                  <input
                    type="text"
                    className="input input_small"
                    placeholder="Phone"
                    {...register("phone", { required: true, ...VALID_PHONE })}
                  />
                  {errors.phone && <span className="erorrs">{(errors.phone?.message as string) || "This field is required"}</span>}
                </div>
              </div>
              <div className="col-lg-6 padding_left_30">
                <div className="form__item">
                  <input
                    type="text"
                    className="input input_small"
                    placeholder="Subject"
                    {...register("subject", { required: true, minLength: 5 })}
                  />
                  {errors.subject && <span className="erorrs">Please describe your topic</span>}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 padding_right_30">
                <div className="form__item form__item_last">
                  <textarea
                    className="input input_small"
                    placeholder="Message"
                    {...register("message", { required: true, minLength: 20 })}
                  ></textarea>
                  {errors.message && <span className="erorrs">Please write a more detailed message</span>}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="recapcha">
                <ReCAPTCHA sitekey="6LcK4UIrAAAAAIyxjMXq8Xyf09FzdY2Y2M_zstuc" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="steps__form_footer">
                <button type="submit" className="button button_bg_red steps-form__submit">
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div id="success_message" style={{ display: "none" }} className="text-center">
        <img src="/img/available.svg" alt="img" />
        <h1 className="text-success text-center">We will be contacting you soon.</h1>
      </div>
    </>
  )
}
